import { Action, createReducer, on } from '@ngrx/store';
import {
    processReverseInvoiceFailure,
    processReverseInvoiceSuccess,
    processReverseInvoiceStart
} from './actions/reverse-invoice.actions';
import { ReverseInvoiceState } from './state/reverse-invoice.state';

export const reverseInvoiceFeatureKey = 'reverse-invoice';

export const initialState: ReverseInvoiceState = {
    signalRLoading: undefined,
    processed: {
        error: undefined,
        complete: false,
        created: []
    }
};

const ReverseInvoiceReducer = createReducer(
    initialState,

    on(
        processReverseInvoiceSuccess,
        (state, action): ReverseInvoiceState => ({
            ...state,
            processed: {
                complete: true,
                created: [...action.created]
            }
        })
    ),

    on(
        processReverseInvoiceFailure,
        (state, action): ReverseInvoiceState => ({
            ...state,
            processed: {
                error: action.error,
                complete: true
            }
        })
    ),

    on(
        processReverseInvoiceStart,
        (state): ReverseInvoiceState => ({
            ...state,
            processed: {
                complete: false
            }
        })
    )
);

export function reverseInvoiceReducer(state: ReverseInvoiceState | undefined, action: Action) {
    return ReverseInvoiceReducer(state, action);
}
